import { useEffect, useState, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import {
  TaxInvoice,
  type TaxInvoiceDoc,
} from '../../../../shared/components/TaxInvoice.js';

/** The vendor's own bill, in the form it will be printed and paid on. */
export function VendorTaxInvoicePage(): ReactNode {
  const { claimId } = useParams<{ claimId: string }>();
  const { token } = useAuth();
  const [doc, setDoc] = useState<TaxInvoiceDoc | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<TaxInvoiceDoc>(`/v1/vendor/billing/claims/${claimId}/document`, {
      token,
    })
      .then(r => {
        if (alive) setDoc(r);
      })
      .catch(e => {
        if (alive) setError((e as Error).message);
      });
    return () => {
      alive = false;
    };
  }, [claimId, token]);

  if (error)
    return (
      <div style={{ padding: 24 }}>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  if (!doc) return <div style={{ padding: 24 }}>Loading...</div>;

  return (
    <div style={{ padding: 24, background: '#f6f8fa' }}>
      <div className="no-print" style={{ marginBottom: 12 }}>
        <button onClick={() => window.print()}>Print / Save as PDF</button>
      </div>
      <TaxInvoice doc={doc} />
      <style>{`@media print { .no-print { display: none } body { background: #fff } }`}</style>
    </div>
  );
}
